import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "session-info-box p-3 rounded-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Sessions: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Time: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Dates: ", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Session Info: ", -1)
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.formatDaysOfWeek(_ctx.coachingSession)), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.formatTimeRange(_ctx.coachingSession)), 1)
    ]),
    _createElementVNode("div", null, [
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(_ctx.formatDateRange(_ctx.coachingSession)), 1)
    ]),
    (_ctx.sessionState.isUSBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", {
            class: "session-description",
            innerHTML: _ctx.coachingSession.description
          }, null, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true)
  ]))
}